import React from "react";
import { Badge, ButtonGroup, Container, Description, LeftContent, PrimaryButton, RightContent, SecondaryButton, TechChip, TechStack, Title, Wrapper } from "./styles";
import Mockup from "./components/Mockup/Mockup";
import { FaWhatsapp } from "react-icons/fa";
import { ArrowRight } from "lucide-react";

const Hero = () => {
    const message = encodeURIComponent(
        "Hola, me interesa conocer los servicios de NanoCode y me gustaría cotizar una solución para mi negocio. ¿Podrían brindarme más información?"
    );

    return (
        <Container id="hero">
            <Wrapper>
                <LeftContent>
                    <Badge>
                        Soluciones Digitales
                    </Badge>

                    <Title>
                        Desarrollamos
                        <br />
                        software que impulsa
                        <br />
                        tu negocio.
                    </Title>

                    <Description>
                        Desde la idea inicial hasta la puesta en producción, 
                        desarrollamos soluciones modernas pensadas para 
                        adaptarse al crecimiento de tu negocio.
                    </Description>

                    <ButtonGroup>
                        <PrimaryButton
                            href={`https://wa.me/5213316710897?text=${message}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Hablemos
                            
                            <FaWhatsapp size={18}/> 
                        </PrimaryButton>

                        <SecondaryButton href="#projects">
                            Ver proyectos
                            <ArrowRight size={18}/>
                        </SecondaryButton>
                    </ButtonGroup>

                    <TechStack>
                        <TechChip>Desarrollo a medida</TechChip>

                        <TechChip>Soluciones escalables</TechChip>

                        <TechChip>Automatización</TechChip>

                        <TechChip>IA Generativa</TechChip>
                    </TechStack>
                </LeftContent>

                <RightContent>
                    <Mockup />
                </RightContent>
            </Wrapper>
        </Container>
    )
};

export default Hero;